import { render, staticRenderFns } from "./InternsViewPage.vue?vue&type=template&id=32c26aca&"
import script from "./InternsViewPage.vue?vue&type=script&lang=js&"
export * from "./InternsViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports